module.exports = __webpack_public_path__ + "static/phantasmic-detective-agency-5b4c326e41029adc7ab42020880c5afb.jpg";